import { __rest } from "tslib";
import React from 'react';
import Transition from 'react-transition-group/Transition';
class SharedTransition extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleEnter = (node, isAppearing) => {
            // Force a repaint.
            // https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215
            node && node.scrollTop; // tslint:disable-line:no-unused-expression
            this.props.onEnter && this.props.onEnter(node, isAppearing);
        };
    }
    render() {
        const _a = this.props, { mountOnEnter = true, unmountOnExit = true, appear = true, children } = _a, restProps = __rest(_a, ["mountOnEnter", "unmountOnExit", "appear", "children"]);
        return (React.createElement(Transition, Object.assign({ mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, appear: appear }, restProps, { onEnter: this.handleEnter }), status => children(status === 'entering' || status === 'entered')));
    }
}
export default SharedTransition;
